import React, { useState, useEffect } from "react";
import { ControlsDropdown } from "./../ControlsDropdown";
import { useExtendedMutation } from "mutations";
import { getPrivateCategories } from "api";

const PrivateCategoriesSettingsControls = ({token}) => {
  const [privateCategories, setPrivateCategories] = useState([]);

  const getSuccessCallback = (data) => {
    setPrivateCategories(data);
  }

  const errorCallback = (error) => {
    console.log(error);
  }

  const getPrivateCategoriesMutation = useExtendedMutation(getPrivateCategories, getSuccessCallback, errorCallback);

  useEffect(() => {
    getPrivateCategoriesMutation.mutateOnVirtualThread(token);
  }, [token]);

  return (
    <>
      <ControlsDropdown
        label={"Choose Category"}
        options={privateCategories}
        onChange={() => {}}
      />
      <ControlsDropdown
        label={"Choose Card Deck"}
        options={["Select A", "B", "C"]}
        onChange={() => {}}
      />
    </>
  );
}

export { PrivateCategoriesSettingsControls }
